
const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web

export default {
  methods: {
    getRedirectUri() {
      let redirectUri = location.href.split('?')[0]
      if(this.$route.query.to) {
        redirectUri += `?to=${this.$route.query.to}`
      }
      return redirectUri
    },
    getLineOAuthToken() {
      let redirectUri = this.getRedirectUri()
      let url = process.env.VUE_APP_API_SERVER_URL.replace(/\/$/, '')
      window.open(url + "/lineRequestToken?redirectUrl=" + redirectUri, "_self")
    },
    async getLineAccessToken() {
      const code = this.$route.query.code
      const state = this.$route.query.state
      if (!(code && state)) {
        return undefined
      }
      const basePath = process.env.VUE_APP_ROUTER_BASE_PATH.replace(/\/$/, '') + this.$route.path
      let path = this.$route.query.to ? `${basePath}?to=${this.$route.query.to}` : basePath
      window.history.replaceState(null, null, path)
      const cmdNo = pb.PlayerLineTokenReq.CommandNo.COMMAND_NO
      const message = pb.PlayerLineTokenReq.create({
        code: code,
        redirectUrl: this.getRedirectUri()
      })
      const encoded = pb.PlayerLineTokenReq.encode(message).finish()
      return await this.post(cmdNo, encoded)
    }
  }
}
